<!--
 * @Author: your name
 * @Date: 2020-08-13 20:08:41
 * @LastEditTime: 2021-03-15 16:40:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/OrderNumber/index.vue
-->
<style scoped lang="sass">
.order_box
  display: flex
  justify-content: center
  align-items: center

  .order_number
    display: flex
    align-content: center
    justify-content: center
    flex-direction: column
    padding: 15px 17px 12px 17px
    border: 1px solid #f1f2f3
    border-radius: 5px
    color: var(--menu-primary-background-colour) !important
    font-size: 30px
    line-height: 52px
    font-weight: bold

  .time
    font-size: 10px
    color: var(--menu-primary-text-colour) !important
    line-height: 12px
    text-align: center
    font-weight: 400
</style>

<template lang="pug">
.order_box
  span.order_number
    span {{ '#' }}{{ orderNo }}
    span.time.o.ls3 {{ createdAt | timeFilters }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'

@Component({
  props: {
    orderNo: [String, Number],
    createdAt: [String, Number],
  },

  filters: {
    timeFilters(val) {
      return dayjs(val).format('DD/MM/YY') + ' at ' + dayjs(val).format('hh:mmA')
    }
  }
})
class OrderNumber extends Vue {
}

export default OrderNumber
</script>
